import * as d3 from "d3";

const draw = props => {
  const { player } = props;
  const { nameslug, totals } = player;
  let params = {
    dom: `shotchart_${nameslug}`,
    id: `shotchart_${nameslug}`,
    width: 1440,
    height: 900,
    data: {
      region: [
        
        `leftWing_${nameslug}`,
        `leftCorner_${nameslug}`,
        `leftFG_${nameslug}`,
        `TopKey_${nameslug}`,
        `Paint_${nameslug}`,
        `Rim_${nameslug}`,
        `rightWing_${nameslug}`,
        `rightFG_${nameslug}`,
        `rightCorner_${nameslug}`,
      ],
      pct: player.pct,
    },
    y: "pct",
    colors: [
      "rgba(92, 143, 242, 0.28)",
      "rgba(92, 143, 242, 0.36)",
      "rgba(92, 143, 242, 0.44)",
      "rgba(92, 143, 242, 0.52)",
      "rgba(92, 143, 242, 0.6)",
      "rgba(92, 143, 242, 0.68)",
      "rgba(92, 143, 242, 0.76)",
      "rgba(92, 143, 242, 0.84)",
      "rgba(92, 143, 242, 0.92)",
      "#5C8FF2"
    ]
  };
  var svg = d3.select(`#shotchart_${nameslug}`);
  //match the data with the regions

  svg.selectAll("path, rect, circle")._groups[0].forEach(function(region) {
    //get the shape with d3
    var regionShape = d3.select(region);
    // console.log(region);
    //look for the id of the shape in the data
    var dataid = d3.values(params.data.region).indexOf(regionShape.attr("id"));
    // console.log(d3.values(params.data.region));
    //if id is greater than 0 then we found the id in data
    //in this example we found a region
    if (dataid >= 0) {
      regionShape
        .datum({
          key: regionShape.attr("id"),
          value: params.data[params.y][dataid]
        })
        .attr("class", "regionData");
    }
  });

  var heatmapColor = d3
    .scaleLinear()
    .domain(d3.range(0, 1, 1.0 / (params.colors.length - 1)))
    .range(params.colors);
  //redundant for now
  //but might need this in the future
  var colorScale = d3
    .scaleLinear()
    .domain([0, 1])
    .range([0, 1]);
  //FUNCTIONS------------------------------------------------------
  // function showPopUp() {
  //   let popUp = document.getElementById("popUp");
  //   if (popUp.style.visibility === "hidden") {
  //     popUp.style.visibility = "visible";
  //   } else {
  //     popUp.style.visibility = "hidden";
  //   }
  // }
  //
  //let alpha = params.data.pct;
  svg.select("#background")
     .style("fill", "white")
  svg
    .selectAll(".regionData")
    .style("fill", function(d){
      let i = params.data.region.indexOf(d.key)
      if (totals[i]['shot']< 5){
        return 'rgb(128, 128, 128)'
      }
      else {
        return 'rgb(8, 98, 158)'
      }
    }
      )
    .style("fill-opacity", function(d){
      let i = params.data.region.indexOf(d.key)
      //console.log(totals[i]['shot'])
      if (totals[i]['shot'] < 5){
        return .3
      }else{
      let alpha = params.data.pct;
      let i = params.data.region.indexOf(d.key)
      //console.log(alpha[i])
      //return Math.sqrt(alpha[i]/100)
      return alpha[i]/100}
    })
    .style("stroke-width", "1")
    .on("mouseover", function() {
      d3.select(this).style("stroke-width", 4).style("stroke", "black");
      //this.parentNode.appendChild(this);
      d3.select(this).attr("class", "regionData active")
      //   d3.select(this).style("fill-opacity", 1.0);
    })
    .on("mouseout", function() {
      d3.select(this).style("stroke-width", 1);
      d3.select(this).attr("class", "regionData")
      //   d3.select(this).style("fill-opacity", 0.2);
    })
    .on("click", function() {
      d3.select(this).style("stroke-width", 4).style("stroke", "black");
      //this.parentNode.appendChild(this);
      d3.select(this).attr("class", "regionData active")
      //   d3.select(this).style("fill-opacity", 1.0);
    });
  // .on("click", showPopUp);

  svg.select('#legend')
    .style("stroke","white")
    .style("fill", "url(#linear-gradient)");
    // .append("text")
    // .attr("class", "legendTitle")
    // .attr("x", 0)
    // .attr("y", 2)
    // .text("Average Global Surface Temperature")
    // .style("color", "white");

  let legendsvg = svg.select('#legend');
  legendsvg
    .append("text")
    .attr("class", "legendTitle")
    .attr("x", 0)
    .attr("y", 2)
    .text("Average Global Surface Temperature");
  let legendScale = d3
    .scaleLinear()
    .range([0, 800])
    .domain([
      0,100
    ]);
  let xAxis =legendsvg
    .append("g")
    .call(
      d3
        .axisBottom(legendScale)
        .tickValues([
          0,100
        ])
    )
    .attr("class", "legendAxis")
    .attr("id", "legendAxis")
    .attr(
      "transform",
      "translate(25, -150)"
    )
    .style("color", "white")
    .style("font-family","Optima");

};
 // ! Creating the legend
 

export default draw;
